import { render, staticRenderFns } from "./DoctorListInSendMess.vue?vue&type=template&id=42300251&scoped=true"
import script from "./DoctorListInSendMess.vue?vue&type=script&lang=js"
export * from "./DoctorListInSendMess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42300251",
  null
  
)

export default component.exports